import {propertyTypes} from "@/services/properties";

const properties = {

  prodottoProperty: {
    code: "1",
    name: "Prodotto",
    description: "",
    order: 0,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  piuTariffeProperty: {
    code: "",
    name: "Più versioni prodotto",
    description: "",
    order: 1,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  codProdCollegatoProperty: {
    code: "3",
    name: "Codice prodotti collegati",
    description: "",
    order: 2,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  compagniaProperty: {
    code: "4",
    name: "Compagnia",
    description: "",
    order: 3,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  canaleProperty: {
    code: "5",
    name: "Canale",
    description: "",
    order: 4,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  distributoriProperty: {
    code: "6",
    name: "Distributori",
    description: "",
    order: 5,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  modDistribuzioneProperty: {
    code: "7",
    name: "Modalità di distribuzione",
    description: "",
    order: 6,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  mercatoProperty: {
    code: "8",
    name: "Mercato",
    description: "",
    order: 7,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  destinatariProperty: {
    code: "9",
    name: "Destinatari",
    description: "",
    order: 8,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  targetMarketProperty: {
    code: "10",
    name: "Target Market",
    description: "",
    order: 9,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  descProdottoProperty: {
    code: "11",
    name: "Descrizione prodotto",
    description: "",
    order: 10,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  lineaBusinessProperty: {
    code: "12",
    name: "Linea di business",
    description: "",
    order: 11,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  ramoProperty: {
    code: "13",
    name: "Ramo",
    description: "",
    order: 12,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  tipologiaGaranzieProperty: {
    code: "14",
    name: "Tipologia garanzie",
    description: "",
    order: 13,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  combinazioneGaranzieProperty: {
    code: "15",
    name: "Combinazione garanzie",
    description: "",
    order: 14,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  prodCommercioProperty: {
    code: "16",
    name: "Prodotto in commercio",
    description: "",
    order: 15,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  inizioCommProperty: {
    code: "17",
    name: "Inizio commercializzazione",
    description: "",
    order: 16,
    value: "",
    values: [],
    dateValue: null,
    valueDescription: "",
    type: propertyTypes.DATE,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  fineCommProperty: {
    code: "18",
    name: "Fine commercializzazione",
    description: "",
    order: 17,
    value: "",
    values: [],
    dateValue: null,
    valueDescription: "",
    type: propertyTypes.DATE,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  edizioneDIPAggProperty: {
    code: "19",
    name: "Edizione DIP aggiuntivo",
    description: "",
    order: 18,
    value: "",
    values: [],
    dateValue: null,
    valueDescription: "",
    type: propertyTypes.DATE,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  tipologiaAssicurazioneProperty: {
    code: "20",
    name: "Tipologia di assicurazione",
    description: "",
    order: 19,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
  premioTipologiaProperty: {
    code: "21",
    name: "Premio - Tipologia",
    description: "",
    order: 20,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  premioDescProperty: {
    code: "22",
    name: "Premio - Descrizione",
    description: "",
    order: 21,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  frazPremioProperty: {
    code: "23",
    name: "Frazionamento del premio",
    description: "",
    order: 22,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  durataProperty: {
    code: "24",
    name: "Durata contrattuale",
    description: "",
    order: 23,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  etaMaxAllaSottoscrizioneProperty: {
    code: "25",
    name: "Età massima alla sottoscrizione",
    description: "",
    order: 24,
    value: "",
    valueSign: "anni",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  etaMaxAllaScadenzaProperty: {
    code: "26",
    name: "Età massima alla scadenza",
    description: "",
    order: 25,
    value: "",
    valueSign: "anni",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  docRichiestaProperty: {
    code: "27",
    name: "Documentazione richiesta",
    description: "",
    order: 26,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Requisiti di sottoscrizione",
    sectionIndex: 2
  },
  rischiAssicuratiRamoVitaProperty: {
    code: "28",
    name: "Rischi Assicurati Ramo Vita",
    description: "",
    order: 27,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  rischiAssicuratiRamoDanniProperty: {
    code: "29",
    name: "Rischi Assicurati Ramo Danni",
    description: "",
    order: 28,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.VALUES,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  decessoQualsiasiCausaProperty: {
    code: "",
    name: "Decesso Qualsiasi Causa",
    description: "",
    order: 29,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  decessoQualsiasiCausaPrestazioneProperty: {
    code: "31",
    name: "Decesso Qualsiasi Causa - Prestazione",
    description: "",
    order: 30,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  decessoDaInfortunioProperty: {
    code: "",
    name: "Decesso Da Infortunio",
    description: "",
    order: 31,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  decessoDaInfortunioPrestazioneProperty: {
    code: "33",
    name: "Decesso Da Infortunio - Prestazione",
    description: "",
    order: 32,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  decessoDaMalattiaProperty: {
    code: "",
    name: "Decesso Da Malattia",
    description: "",
    order: 33,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  decessoDaMalattiaPrestazioneProperty: {
    code: "35",
    name: "Decesso Da Malattia - Prestazione",
    description: "",
    order: 34,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  invaliditaPermanenteQualsiasiCausaProperty: {
    code: "",
    name: "Invalidità Permanente (qualsiasi causa)",
    description: "",
    order: 35,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  invaliditaPermanenteQualsiasiCausaPrestazioneProperty: {
    code: "37",
    name: "Invalidità Permanente (qualsiasi causa) - Prestazione",
    description: "",
    order: 36,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  invaliditaPermanenteDaInfortunioProperty: {
    code: "",
    name: "Invalidità Permanente da Infortunio",
    description: "",
    order: 37,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  invaliditaPermanenteDaInfortunioPrestazioneProperty: {
    code: "39",
    name: "Invalidità Permanente da Infortunio - Prestazione",
    description: "",
    order: 38,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  invaliditaPermanenteDaMalattiaProperty: {
    code: "",
    name: "Invalidità Permanente da Malattia",
    description: "",
    order: 39,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  invaliditaPermanenteDaMalattiaPrestazioneProperty: {
    code: "41",
    name: "Invalidità Permanente da Malattia - Prestazione",
    description: "",
    order: 40,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  inabilitaTemporaneaQualsiasiCausaProperty: {
    code: "",
    name: "Inabilità Temporanea (qualsiasi causa)",
    description: "",
    order: 41,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  inabilitaTemporaneaQualsiasiCausaPrestazioneProperty: {
    code: "43",
    name: "Inabilità Temporanea (qualsiasi causa) - Prestazione",
    description: "",
    order: 42,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  inabilitaTemporaneaDaInfortunioProperty: {
    code: "",
    name: "Inabilità Temporanea da infortunio",
    description: "",
    order: 43,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  inabilitaTemporaneaDaInfortunioPrestazioneProperty: {
    code: "45",
    name: "Inabilità Temporanea da infortunio - Prestazione",
    description: "",
    order: 44,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  inabilitaTemporaneaDaMalattiaProperty: {
    code: "",
    name: "Inabilità Temporanea da malattia",
    description: "",
    order: 45,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  inabilitaTemporaneaDaMalattiaPrestazioneProperty: {
    code: "47",
    name: "Inabilità Temporanea da malattia - Prestazione",
    description: "",
    order: 46,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  malattieGraviProperty: {
    code: "",
    name: "Malattie gravi",
    description: "",
    order: 47,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  malattieGraviPrestazioneProperty: {
    code: "49",
    name: "Malattie gravi - Prestazione",
    description: "",
    order: 48,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  ricoveroOspedalieroProperty: {
    code: "",
    name: "Ricovero ospedaliero",
    description: "",
    order: 49,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  ricoveroOspedalieroPrestazioneProperty: {
    code: "51",
    name: "Ricovero ospedaliero - Prestazione",
    description: "",
    order: 50,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  ricoveroGrandeInterventoChirurgicoProperty: {
    code: "",
    name: "Ricovero per Grande Intervento Chirurgico",
    description: "",
    order: 51,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  ricoveroGrandeInterventoChirurgicoPrestazioneProperty: {
    code: "53",
    name: "Ricovero per Grande Intervento Chirurgico - Prestazione",
    description: "",
    order: 52,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  perditaImpiegoProperty: {
    code: "",
    name: "Perdita d'impiego",
    description: "",
    order: 53,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  perditaImpiegoPrestazioneProperty: {
    code: "55",
    name: "Perdita d'impiego - Prestazione",
    description: "",
    order: 54,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  altriRischiProperty: {
    code: "56",
    name: "Altri rischi",
    description: "",
    order: 55,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Garanzie assicurative",
    sectionIndex: 3
  },
  costiRamoVitaProperty: {
    code: "57",
    name: "Costi - Ramo Vita",
    description: "",
    order: 56,
    value: "",
    valueSign: "%",
    values: [],
    valueDescription: "",
    type: propertyTypes.NUMBER,
    sectionName: "Costi",
    sectionIndex: 4
  },
  costiRamoDanniProperty: {
    code: "58",
    name: "Costi - Ramo Danni",
    description: "",
    order: 57,
    value: "",
    valueSign: "%",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Costi",
    sectionIndex: 4
  },
  interessiFrazProperty: {
    code: "59",
    name: "Interessi di frazionamento",
    description: "",
    order: 58,
    value: "",
    values: [],
    valueDescription: "",
    frazionamento: {
      mensile: "", mensileSign: "%",
      bimestrale: "", bimestraleSign: "%",
      trimestrale: "", trimestraleSign: "%",
      quadrimestrale: "", quadrimestraleSign: "%",
      semestrale: "", semestraleSign: "%",
    },
    type: propertyTypes.FRAZIONAMENTO,
    sectionName: "Costi",
    sectionIndex: 4
  },
  retrDistrVitaProperty: {
    code: "60",
    name: "Retrocessione alla distribuzione - Ramo Vita",
    description: "",
    order: 59,
    value: "",
    valueSign: "%",
    values: [],
    valueDescription: "",
    type: propertyTypes.NUMBER,
    sectionName: "Retrocessione alla distribuzione",
    sectionIndex: 5
  },
  retrDistrDanniProperty: {
    code: "61",
    name: "Retrocessione alla distribuzione - Ramo Danni",
    description: "",
    order: 60,
    value: "",
    valueSign: "%",
    values: [],
    valueDescription: "",
    type: propertyTypes.NUMBER,
    sectionName: "Retrocessione alla distribuzione",
    sectionIndex: 5
  },
  retrDistrSpecificheProperty: {
    code: "62",
    name: "Retrocessione alla distribuzione - Specifiche",
    description: "",
    order: 61,
    value: "",
    valueSign: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Retrocessione alla distribuzione",
    sectionIndex: 5
  },
  // Note
  noteProperty: {
    code: "63",
    name: "Note",
    description: "",
    order: 62,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Note",
    sectionIndex: 6
  },
  codProdottoProperty: {
    code: "64",
    name: "Codice prodotto",
    description: "",
    order: 0,
    value: "",
    values: [],
    valueDescription: "",
    type: propertyTypes.STRING,
    sectionName: "Caratteristiche generali",
    sectionIndex: 1
  },
};

export default properties;
